import ExploreNFTsContainer from '../../containers/ExploreNFTs';

const ExploreNFTs = () => {

  return <ExploreNFTsContainer />
}

export default ExploreNFTs;